import * as React from 'react';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import * as PropTypes from "prop-types";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import MDEditor, { commands } from '@uiw/react-md-editor';
import authService from '../api-authorization/AuthorizeService'
import {useParams} from "react-router-dom";
import moment from "moment/moment";
import {useEffect, useRef} from "react";
import SimpleBackdrop from "../backdrop";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { FileUploader } from "react-drag-drop-files";
import VideoSummaryCard from "../videoSummary";
import AddIssueUpdate from "../issues/addIssueUpdate";
import IssueEvent from "../issues/issueEvent";
import List from "@mui/material/List";
import {CardHeader, Chip, ListItem, ListItemAvatar, Select} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ListItemText from "@mui/material/ListItemText";
import LockIcon from "@mui/icons-material/Lock";
import IssueStatusDisplay from "../issues/issueStatusDisplay";
import Person2Icon from "@mui/icons-material/Person2";
import MenuItem from "@mui/material/MenuItem";
import {DatePicker} from "@mui/x-date-pickers";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import Slide from '@mui/material/Slide';
import AnnotateScreenDialog from "../ai/annotatedialog";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import {HelpText} from "../HelpText";
import Annotator from "../ai/annotator";
import Stack from "@mui/material/Stack";
import FormDialog from "./formdialog";
import StyledActionButton from "../GreenButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditIcon from "@mui/icons-material/Edit";
import ArchiveIcon from "@mui/icons-material/Archive";
import Alert from "@mui/material/Alert";
import {StyledMenu} from "../styledMenu";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ListItemIcon from '@mui/material/ListItemIcon';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import Tooltip from "@mui/material/Tooltip";
import {Link} from "react-router-dom"
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


PersonAddIcon.propTypes = {fontSize: PropTypes.string};


const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];
const SMALL_BOX_MIN_WIDTH = 16;
const SMALL_BOX_MIN_HEIGHT = 16;
const SMALL_BOX_MIN_AREA = 32 * 32;
const SMALL_BOX_TOOLTIP = "Image has small annotation(s): width < 16px, height < 16px, or area < 32x32px.";
const SMALL_ANN_FETCH_CONCURRENCY = 4;
const SMALL_ANN_FLUSH_MS = 75;

const parseAnnotationPoints = (rawPoints) => {
    if (Array.isArray(rawPoints)) return rawPoints;
    if (typeof rawPoints === "string") {
        try {
            const parsed = JSON.parse(rawPoints);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
    return [];
};

const getAnnotationBoxDimensions = (ann) => {
    if (!ann || typeof ann !== "object") return null;

    const shape = (ann.shape || "rect").toString().toLowerCase();
    if (shape === "polygon") {
        const points = parseAnnotationPoints(ann.points);
        if (!points.length) return null;
        const xs = points.map((p) => Number(p?.x) || 0);
        const ys = points.map((p) => Number(p?.y) || 0);
        const width = Math.max(...xs) - Math.min(...xs);
        const height = Math.max(...ys) - Math.min(...ys);
        return { width, height, area: width * height };
    }

    const left = Number(ann.left) || 0;
    const top = Number(ann.top) || 0;
    const rightCandidate = Number(ann.right);
    const bottomCandidate = Number(ann.bottom);
    const widthCandidate = Number(ann.width);
    const heightCandidate = Number(ann.height);

    const right = Number.isFinite(rightCandidate) ? rightCandidate : (left + (Number.isFinite(widthCandidate) ? widthCandidate : 0));
    const bottom = Number.isFinite(bottomCandidate) ? bottomCandidate : (top + (Number.isFinite(heightCandidate) ? heightCandidate : 0));
    const width = Math.abs(right - left);
    const height = Math.abs(bottom - top);
    return { width, height, area: width * height };
};

const annotationMatchesSmallRule = (ann) => {
    const dims = getAnnotationBoxDimensions(ann);
    if (!dims) return false;
    return (
        dims.width < SMALL_BOX_MIN_WIDTH ||
        dims.height < SMALL_BOX_MIN_HEIGHT ||
        dims.area < SMALL_BOX_MIN_AREA
    );
};


export default function BrandDetails({updateTitle}) {
    const [project, setProject] = React.useState({keywords: []});
    const [brand, setBrand] = React.useState();
    const {id} = useParams();
    const [loading, setLoading] = React.useState(true);
    const [selectedLabelId, setSelectedLabelId] = React.useState("");

    const [files, setFiles] = React.useState([]);
    const uploadFile = async (file) =>{

        const formData = new FormData();
        formData.append('files', file[0]);
        const response = await fetch('/api/organisation/brands/' + id + '/logos', {
            method: 'POST',
            body: formData,
        });
        console.log(response);
        return response;
    }

    
    const handleChange = (file) => {
        setFiles(prevArray => [...files, file])
        console.log(file[0])
        uploadFile(file) .then(data => {
            console.log('Data received:', data);
        })
            .catch(error => {
                console.error('Error:', error);
            });
        
        console.log(files);
    };
    const [uploadStatus, setUploadStatus] = React.useState([]);

    const [queue, setQueue] = React.useState([]);
    const queueRef = useRef(null);
    const upload = () => {
        
        console.log(queue);
        if(queueRef.current.length == 0){
            fetchData(true)
                // make sure to catch any error
                .catch(console.error);
            return;
        }
        let q = queueRef.current;
        console.log(q);
        let file = q[0];
        setQueue(q.filter(f => f !== file));
        queueRef.current = q.filter(f => f !== file)
        console.log('uploading file:', file);
        const formData = new FormData();
        formData.append('files', file);
        fetch('/api/organisation/brands/' + id + '/usage', {
            method: 'POST',
            body: formData,
        }).then(data => {
                console.log('Data received:', data);
                // Update the status of the file in uploadStatus to 'Complete'
                setUploadStatus(prevStatus => prevStatus.map(item =>
                    item.name === file.name ? { ...item, status: 'Complete' } : item
                ));
                
                setTimeout(() => {
                    upload();
                }, 500);
            })
            .catch(error => {
                console.error('Error:', error);
                // Update the status of the file in uploadStatus to 'Error'
                setUploadStatus(prevStatus => prevStatus.map(item =>
                    item.name === file.name ? { ...item, status: 'Error' } : item
                ));
            });
    };
    const handleChangeUsage = (files) => {
        // Create a queue of files to be uploaded
        console.log(files);
        let f = [];
        for (let i = 0; i < files.length; i++)
        {
            let file = files[i];
            setUploadStatus(prevStatus => [...prevStatus, {name: file.name, status: 'Pending...'}]);
            f.push(file);
        }
        setQueue(f);
        queueRef.current = f;
        // Function to upload a file
   
            upload();
        
    };
    React.useEffect(() => {
        const onPaste = (event) => {
            const active = document.activeElement;
            const tag = (active?.tagName || "").toLowerCase();
            const isTypingTarget =
                tag === "input" ||
                tag === "textarea" ||
                active?.isContentEditable;

            if (isTypingTarget) {
                return;
            }

            const clipboardItems = event.clipboardData?.items;
            if (!clipboardItems?.length) {
                return;
            }

            const imageFiles = [];
            for (let i = 0; i < clipboardItems.length; i++) {
                const item = clipboardItems[i];
                if (item.kind === "file" && item.type?.startsWith("image/")) {
                    const file = item.getAsFile();
                    if (file) {
                        imageFiles.push(file);
                    }
                }
            }

            if (!imageFiles.length) {
                return;
            }

            event.preventDefault();
            handleChangeUsage(imageFiles);
        };

        window.addEventListener("paste", onPaste);
        return () => window.removeEventListener("paste", onPaste);
    }, [handleChangeUsage]);

    const sortedImages = React.useMemo(() => {
        const arr = Array.isArray(brand?.images) ? brand.images : [];
        return arr.slice().sort((a, b) => (b?.id ?? 0) - (a?.id ?? 0));
    }, [brand?.images]);
    const [showUnannotatedOnly, setShowUnannotatedOnly] = React.useState(false);
    const [smallAnnotationByImageId, setSmallAnnotationByImageId] = React.useState({});
    const smallAnnQueueRef = React.useRef([]);
    const smallAnnInFlightRef = React.useRef(new Set());
    const smallAnnSeenRef = React.useRef(new Set());
    const smallAnnPatchRef = React.useRef({});
    const smallAnnFlushTimerRef = React.useRef(null);
    const smallAnnRunIdRef = React.useRef(0);

    const flushSmallAnnotationPatch = React.useCallback(() => {
        const patch = smallAnnPatchRef.current;
        smallAnnPatchRef.current = {};
        if (!patch || Object.keys(patch).length === 0) return;
        setSmallAnnotationByImageId((prev) => ({ ...prev, ...patch }));
    }, []);

    const scheduleSmallAnnotationFlush = React.useCallback(() => {
        if (smallAnnFlushTimerRef.current) return;
        smallAnnFlushTimerRef.current = setTimeout(() => {
            smallAnnFlushTimerRef.current = null;
            flushSmallAnnotationPatch();
        }, SMALL_ANN_FLUSH_MS);
    }, [flushSmallAnnotationPatch]);

    const processSmallAnnotationQueue = React.useCallback((runId) => {
        while (
            smallAnnInFlightRef.current.size < SMALL_ANN_FETCH_CONCURRENCY &&
            smallAnnQueueRef.current.length > 0 &&
            runId === smallAnnRunIdRef.current
        ) {
            const imageId = smallAnnQueueRef.current.shift();
            if (!Number.isFinite(imageId) || imageId <= 0) continue;
            if (smallAnnSeenRef.current.has(imageId) || smallAnnInFlightRef.current.has(imageId)) continue;

            smallAnnInFlightRef.current.add(imageId);
            fetch(`/api/organisation/labels/img/${imageId}/annotations`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
                .then((response) => {
                    authService.followIfLoginRedirect(response);
                    if (!response.ok) return null;
                    return response.json();
                })
                .then((annotations) => {
                    if (runId !== smallAnnRunIdRef.current) return;
                    const hasSmall = Array.isArray(annotations) && annotations.some(annotationMatchesSmallRule);
                    smallAnnPatchRef.current[imageId] = hasSmall;
                    scheduleSmallAnnotationFlush();
                })
                .catch(() => {
                    // Ignore; listing can still render without this optional warning.
                })
                .finally(() => {
                    smallAnnInFlightRef.current.delete(imageId);
                    smallAnnSeenRef.current.add(imageId);
                    if (runId === smallAnnRunIdRef.current) {
                        processSmallAnnotationQueue(runId);
                    }
                });
        }
    }, [scheduleSmallAnnotationFlush]);

    const refreshSmallAnnotationFlagForImage = React.useCallback(async (imageId) => {
        const numericId = Number(imageId);
        if (!Number.isFinite(numericId) || numericId <= 0) return;
        smallAnnSeenRef.current.delete(numericId);
        smallAnnPatchRef.current[numericId] = undefined;
        try {
            const response = await fetch(`/api/organisation/labels/img/${numericId}/annotations`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            authService.followIfLoginRedirect(response);
            if (!response.ok) return;
            const annotations = await response.json();
            const hasSmall = Array.isArray(annotations) && annotations.some(annotationMatchesSmallRule);
            setSmallAnnotationByImageId((prev) => ({ ...prev, [numericId]: hasSmall }));
            smallAnnSeenRef.current.add(numericId);
        } catch {
            // Ignore; listing can still render without this optional warning.
        }
    }, []);

    const visibleImages = React.useMemo(() => {
        if (!showUnannotatedOnly) return sortedImages;
        return sortedImages.filter((img) => (img?.annotations ?? 0) === 0);
    }, [sortedImages, showUnannotatedOnly]);

    React.useEffect(() => {
        // Reset cache when switching brands.
        smallAnnRunIdRef.current += 1;
        smallAnnQueueRef.current = [];
        smallAnnInFlightRef.current = new Set();
        smallAnnSeenRef.current = new Set();
        smallAnnPatchRef.current = {};
        if (smallAnnFlushTimerRef.current) {
            clearTimeout(smallAnnFlushTimerRef.current);
            smallAnnFlushTimerRef.current = null;
        }
        setSmallAnnotationByImageId({});
    }, [id]);

    React.useEffect(() => {
        const runId = smallAnnRunIdRef.current;
        const targets = visibleImages
            .filter((img) => (img?.annotations ?? 0) > 0)
            .map((img) => Number(img.id))
            .filter((imageId) => Number.isFinite(imageId) && !smallAnnSeenRef.current.has(imageId));

        if (!targets.length) return;

        smallAnnQueueRef.current.push(...targets);
        processSmallAnnotationQueue(runId);
    }, [visibleImages, processSmallAnnotationQueue]);

    React.useEffect(() => () => {
        smallAnnRunIdRef.current += 1;
        if (smallAnnFlushTimerRef.current) {
            clearTimeout(smallAnnFlushTimerRef.current);
            smallAnnFlushTimerRef.current = null;
        }
    }, []);
    
    const [pendingOpen, setPendingOpen] = React.useState(null);


    React.useEffect(() => {
        if (pendingOpen && visibleImages.length) {
            const { id, type } = pendingOpen;
            setPendingOpen(null);
            // reuse the same logic
            const targetId = Number(id);
            const idx = visibleImages.findIndex((img) => Number(img.id) === targetId);
            const safeIdx = idx >= 0 ? idx : 0;

            setLogoId(targetId);
            setUsageId(type);
            setOpen(true);
            setCurrentIndex(safeIdx);
            setCurrentItem(visibleImages[safeIdx] ?? null);
        }
    }, [pendingOpen, visibleImages]);
    
    const fetchData = async (isLoading) => {
        if(isLoading) {
            setLoading(true);
        }
        //const token = await authService.getAccessToken();
        const query = selectedLabelId ? `?labelId=${encodeURIComponent(selectedLabelId)}` : "";
        const response = await fetch('/api/organisation/brands/' + id + '/details' + query, {
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        });
        authService.followIfLoginRedirect(response);
        const data = await response.json();
        setBrand(data);
        updateTitle(data.name);
        if(isLoading){
            setLoading(false);
        }
    }


    useEffect(() => {
        fetchData(true)
            // make sure to catch any error
            .catch(console.error);

    }, [id, selectedLabelId])

    


    function loadingView() {
        return (<div>Loading.. <SimpleBackdrop open={loading}/></div>)
    }

    const [open, setOpen] = React.useState(false);
    const [logoId, setLogoId] = React.useState(-1);
    const [annotatorDirty, setAnnotatorDirty] = React.useState(false);
    const [confirmNavOpen, setConfirmNavOpen] = React.useState(false);
    const [confirmNavError, setConfirmNavError] = React.useState("");
    const [pendingNavAction, setPendingNavAction] = React.useState(null);
    const [annotatorSaveHandler, setAnnotatorSaveHandler] = React.useState(null);
    const [annotatorMoveHandler, setAnnotatorMoveHandler] = React.useState(null);
    const [annotatorDeleteHandler, setAnnotatorDeleteHandler] = React.useState(null);
    const [annotatorRedactHandler, setAnnotatorRedactHandler] = React.useState(null);

    const [nextIndex, setNextId] = React.useState(-1);
    const [usageId, setUsageId] = React.useState('none');
    const handleClickOpen = (id, type, idx) => {
        setLogoId(id)
        console.log(id)
        setUsageId(type);
        setOpen(true);
        setAnnotatorDirty(false);
        setCurrentIndex(idx);
        
        setCurrentItem(brand.images[idx])
    };

    const closeAnnotatorNow = () => {
        setOpen(false);
        setAnnotatorDirty(false);

        fetchData(false)
            // make sure to catch any error
            .catch(console.error);

    };
    const requestNavigation = (action) => {
        if (annotatorDirty) {
            setConfirmNavError("");
            setPendingNavAction(() => action);
            setConfirmNavOpen(true);
            return;
        }
        action();
    };
    const handleClose = () => requestNavigation(closeAnnotatorNow);
    const onSaveDialog = (row, type) => {
        //setOpen(false);
        console.log('onSaveDialog');
        refreshSmallAnnotationFlagForImage(row).catch(() => {});
        var items = type == 'logo' ? brand.images.filter(e=>e.image_type === 0) : brand.images.filter(e=>e.image_type === 1);
        var index = items.findIndex(x => x.id === row);
        
        if (index < items.length - 1) {
            setNextId(index+1);
            console.log("Next index exists");
            setTimeout(() => {
                //setLogoId(nextIndex);
                //setOpen(true);
            }, 200); // Delay of 500ms
        } else {
            console.log("Next index does not exist");
            //setOpen(false);
            //setNextId(-1);
        }
    };

    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [currentItem, setCurrentItem] = React.useState(null);
    const navigationDirectionRef = React.useRef(null);
    const imagePreloadRef = React.useRef(new Map());

    const preloadImage = React.useCallback((item) => {
        const imageId = Number(item?.id);
        if (!Number.isFinite(imageId) || imageId <= 0) return;
        const url = `/api/organisation/brands/img/${imageId}`;
        if (imagePreloadRef.current.has(url)) return;
        const image = new window.Image();
        image.decoding = 'async';
        image.src = url;
        imagePreloadRef.current.set(url, image);
    }, []);

    React.useEffect(() => {
        if (!open || !visibleImages.length || currentIndex < 0) return;
        const nextIndex = (currentIndex + 1) % visibleImages.length;
        const previousIndex = (currentIndex - 1 + visibleImages.length) % visibleImages.length;
        const orderedIndexes = navigationDirectionRef.current === 'previous'
            ? [previousIndex, nextIndex]
            : [nextIndex, previousIndex];
        // Keep the immediate neighbours warm; the first request follows the
        // direction the user is currently travelling.
        orderedIndexes.forEach(index => preloadImage(visibleImages[index]));
    }, [open, currentIndex, visibleImages, preloadImage]);

    const loadNextItem = () => {
        if (!visibleImages?.length) return;
        navigationDirectionRef.current = 'next';
        const next = (currentIndex + 1) % visibleImages.length;
        setCurrentIndex(next);
        setCurrentItem(visibleImages[next]);
    };

    const loadPrevItem = () => {
        if (!visibleImages?.length) return;
        navigationDirectionRef.current = 'previous';
        const next = (currentIndex - 1 + visibleImages.length) % visibleImages.length;
        setCurrentIndex(next);
        setCurrentItem(visibleImages[next]);
    };
    
    const brandEditCb = () => {}

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const [handleEditMode, setHandleEdit] = React.useState(false);
    const handleEdit = () => {
        setAnchorEl(null);
        setHandleEdit(true);
    };
    
    const handleCloseEdit = () => {
        setHandleEdit(false)
        setAnchorEl(null);
    }
    

    const handleClickOpen2 = React.useCallback((imageId, type) => {
        const targetImageId = Number(imageId);
        const idx = visibleImages.findIndex((img) => Number(img.id) === targetImageId);
        if (idx < 0) {
            return;
        }

        setLogoId(targetImageId);
        setUsageId(type);
        setOpen(true);
        setAnnotatorDirty(false);
        setCurrentIndex(idx);
        navigationDirectionRef.current = null;

        // Always use the exact selected image from the visible list.
        const item = visibleImages[idx] ?? null;
        setCurrentItem(item);
    }, [visibleImages]);

    const handleImageDeleted = (deletedId) => {
        // If there was only one image, close the dialog
        if ((visibleImages?.length || 0) <= 1) {
            setOpen(false);
            setAnnotatorDirty(false);
            setBrand(prev => prev ? { ...prev, images: (prev.images || []).filter(i => i.id !== deletedId) } : prev);
            return;
        }

        // Move to previous image (same as clicking "← Go Back")
        const prevIdx = (currentIndex - 1 + visibleImages.length) % visibleImages.length;
        setCurrentIndex(prevIdx);
        setCurrentItem(visibleImages[prevIdx]);

        // Remove the deleted image from list
        setBrand(prev => prev ? { ...prev, images: (prev.images || []).filter(i => i.id !== deletedId) } : prev);

        // (optional) refresh server state quietly
        // fetchData(false).catch(console.error);
    };
    const handleImageMoved = (movedId) => {
        const remaining = visibleImages.filter((img) => img.id !== movedId);

        setAnnotatorDirty(false);
        setBrand(prev => prev ? { ...prev, images: (prev.images || []).filter(i => i.id !== movedId) } : prev);

        if (remaining.length === 0) {
            setOpen(false);
            fetchData(false).catch(console.error);
            return;
        }

        const next = Math.min(currentIndex, remaining.length - 1);
        setCurrentIndex(next);
        setCurrentItem(remaining[next]);
        setOpen(true);
        fetchData(false).catch(console.error);
    };
    React.useEffect(() => {
        if (!open) return;

        if (!visibleImages.length) {
            setOpen(false);
            setCurrentItem(null);
            setCurrentIndex(0);
            return;
        }

        const idx = visibleImages.findIndex((img) => img.id === currentItem?.id);
        const safeIdx = idx >= 0 ? idx : Math.min(currentIndex, visibleImages.length - 1);
        if (safeIdx !== currentIndex || currentItem?.id !== visibleImages[safeIdx]?.id) {
            setCurrentIndex(safeIdx);
            setCurrentItem(visibleImages[safeIdx]);
        }
    }, [open, visibleImages, currentItem?.id, currentIndex]);
    const handleConfirmSaveAndContinue = async () => {
        setConfirmNavError("");
        if (typeof annotatorSaveHandler === "function") {
            const ok = await annotatorSaveHandler();
            if (!ok) {
                setConfirmNavError("Save failed. Please try again.");
                return;
            }
        }
        const action = pendingNavAction;
        setConfirmNavOpen(false);
        setPendingNavAction(null);
        setAnnotatorDirty(false);
        if (typeof action === "function") {
            action();
        }
    };
    const handleConfirmDiscardAndContinue = () => {
        const action = pendingNavAction;
        setConfirmNavOpen(false);
        setPendingNavAction(null);
        setAnnotatorDirty(false);
        if (typeof action === "function") {
            action();
        }
    };
    const handleConfirmCancel = () => {
        setConfirmNavOpen(false);
        setConfirmNavError("");
        setPendingNavAction(null);
    };

    React.useEffect(() => {
        if (!open) return undefined;

        const onKeyDown = (e) => {
            const active = document.activeElement;
            const tag = (active?.tagName || "").toLowerCase();
            const isTypingTarget =
                tag === "input" ||
                tag === "textarea" ||
                active?.isContentEditable;

            if (isTypingTarget || confirmNavOpen) return;

            if (e.key === "ArrowLeft") {
                e.preventDefault();
                requestNavigation(loadPrevItem);
                return;
            }

            if (e.key === "ArrowRight") {
                e.preventDefault();
                requestNavigation(loadNextItem);
            }
        };

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [open, confirmNavOpen, requestNavigation, loadPrevItem, loadNextItem]);
    
    const loadedView = () => {
        return (
            <div>
                {/* Edit dialog trigger */}
                <FormDialog brand={brand} cb={brandEditCb} openEditMode={handleEditMode} onClose={handleCloseEdit} />

                {/* Page header */}
                <Stack component="header" direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} justifyContent="space-between" spacing={2} sx={{ mb: 2 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="h5" fontWeight={600}>Brand assets & usage</Typography>
                        {project?.project_status === 1 && (
                            <Alert severity="warning" sx={{ py: 0.5 }}>
                                <Typography fontWeight={600}>This project is archived.</Typography>
                                <Typography sx={{ fontSize: 12 }}>{project.archived_by.display_name} archived it on {moment(project.date_project_archived).format('llll')}</Typography>
                            </Alert>
                        )}
                    </Stack>

                    {/* Actions */}
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
                        <StyledActionButton
                            id="demo-customized-button"
                            aria-controls={openMenu ? 'demo-customized-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openMenu ? 'true' : undefined}
                            variant="contained"
                            disableElevation
                            onClick={handleClick}
                            endIcon={<KeyboardArrowDownIcon />}
                            sx={{ fontSize: 14 }}
                        >
                            Options
                        </StyledActionButton>
                        <StyledMenu
                            id="demo-customized-menu"
                            MenuListProps={{ 'aria-labelledby': 'demo-customized-button' }}
                            anchorEl={anchorEl}
                            open={openMenu}
                            onClose={handleCloseMenu}
                        >
                            <MenuItem onClick={handleEdit} disableRipple>
                                <EditIcon />
                                Edit
                            </MenuItem>
                            <Divider sx={{ my: 0.5 }} />
                        </StyledMenu>
                    </Stack>
                </Stack>

                {/* Upload + guidance */}
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={7} lg={8}>
                        <Card variant="outlined" sx={{ borderRadius: 3 }}>
                            <CardHeader titleTypographyProps={{ variant: 'h6' }} title="Upload new assets" sx={{ pb: 0 }} />
                            <CardContent sx={{ pt: 1 }}>
                                {/* Compact dropzone */}
                                <Box
                                    sx={{
                                        border: '1px dashed',
                                        borderColor: 'divider',
                                        borderRadius: 2,
                                        p: 1.25,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1.5
                                    }}
                                >
                                    <CloudUploadIcon fontSize="small" />
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <FileUploader
                                            handleChange={handleChangeUsage}
                                            name="file"
                                            types={fileTypes}
                                            multiple={true}
                                        />
                                    </Box>
                                </Box>


                                {uploadStatus.length > 0 && (
                                    <Box sx={{ mt: 1.5 }}>
                                        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Upload status</Typography>
                                        <List dense sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
                                            {uploadStatus.map((file, index) => (
                                                <ListItem key={index} secondaryAction={<Typography variant="caption">{file.status}</Typography>}>
                                                    <ListItemIcon><InsertDriveFileIcon fontSize="small" /></ListItemIcon>
                                                    <ListItemText
                                                        primary={<Typography variant="body2" noWrap title={file.name}>{file.name}</Typography>}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                )}

                                <HelpText sx={{ mt: 2 }}>
                                    Upload posters, photos or real‑world examples of where your logos are used — screenshots, photos, prints. The more varied they are, the better and more accurate matches will be.
                                    <p>Try different colours, backgrounds and usage contexts.</p>
                                </HelpText>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Key stats / quick glance */}
                    <Grid item xs={12} md={5} lg={4}>
                        <Card variant="outlined" sx={{ height: '100%', borderRadius: 3 }}>
                            <CardHeader titleTypographyProps={{ variant: 'h6' }} title="At a glance" sx={{ pb: 0 }} />
                            <CardContent sx={{ pt: 1 }}>
                                <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
                                    <Chip label={`Files: ${brand?.images?.length ?? 0}`} />
                                    <Chip label={`Domains: ${brand?.domains?.length ?? 0}`} />
                                </Stack>

                                <Divider sx={{ my: 1 }} />

                                {brand?.last_seen_date ? (
                                    <Typography variant="body2">
                                        <strong>Last seen:</strong>&nbsp;
                                        {moment(brand.last_seen_date).format('DD MMM YYYY HH:mm')}
                                        &nbsp;in&nbsp;
                                        <Link to={`/projects/${brand.last_seen_project_id}`}>
                                            {brand.last_seen_project_name ?? `Project #${brand.last_seen_project_id}`}
                                        </Link>
                                    </Typography>
                                ) : (
                                    <Typography variant="body2" color="text.secondary">
                                        Never seen in any project
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                {brand?.recent_entries?.length > 0 && (
                    <Card variant="outlined" sx={{ borderRadius: 3, mt: 2, mb: 2}}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Seen in videos (latest 10)</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Video</TableCell>
                                        <TableCell>Project</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {brand.recent_entries.map(e => (
                                        <TableRow key={e.report_entry_id} hover>
                                            <TableCell>
                                                <Typography variant="body2" noWrap title={e.video_title}>{e.video_title}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" noWrap title={e.project_name}>{e.project_name}</Typography>
                                            </TableCell>
                                            <TableCell>{moment(e.date_created).format('DD MMM YYYY HH:mm')}</TableCell>
                                            <TableCell align="right">
                                                {/* Deep link that should open the drawer on load */}
                                                <Link to={`/projects/${e.project_id}/entry/${e.report_entry_id}`}>Open</Link>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                )}
                {/* Files table */}
                <Card variant="outlined" sx={{ borderRadius: 3 }}>
                    <CardHeader
                        titleTypographyProps={{ variant: 'h6' }}
                        title="Files"
                        sx={{ pb: 0 }}
                        action={
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={1}
                                alignItems={{ xs: "stretch", sm: "center" }}
                                sx={{ width: "100%" }}
                            >
                                <Select
                                    size="small"
                                    value={selectedLabelId}
                                    displayEmpty
                                    onChange={(event) => setSelectedLabelId(event.target.value)}
                                    aria-label="Filter images by annotation label"
                                    sx={{
                                        minWidth: { xs: 180, sm: 210 },
                                        maxWidth: { xs: "100%", sm: 280 },
                                    }}
                                >
                                    <MenuItem value="">All annotation labels</MenuItem>
                                    {(brand?.labels || []).map((label) => (
                                        <MenuItem key={label.id} value={String(label.id)}>{label.name}</MenuItem>
                                    ))}
                                </Select>
                                <Button
                                    size="small"
                                    variant={showUnannotatedOnly ? "contained" : "outlined"}
                                    onClick={() => setShowUnannotatedOnly(prev => !prev)}
                                >
                                    {showUnannotatedOnly ? "Showing Unannotated" : "Unannotated Only"}
                                </Button>
                            </Stack>
                        }
                    />
                    <CardContent sx={{ pt: 0 }}>
                        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, maxHeight: 520 }}>
                            <Table stickyHeader aria-label="files table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: '55%' }}>File</TableCell>
                                        <TableCell align="right">Annotations</TableCell>
                                        <TableCell align="right" sx={{ width: 120 }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {visibleImages// highest id first
                                        .map((row, idx) => (
                                        <TableRow key={row.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">
                                                <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                                                    <InsertDriveFileIcon fontSize="small" />
                                                    <Box sx={{ minWidth: 0 }}>
                                                        {/* Some image names can be wrong — show filename but gracefully truncate, and expose full in title */}
                                                        <Typography variant="body2" noWrap title={row.filename}>{row.filename || `Image #${row.id}`}</Typography>
                                                        <Typography variant="caption" color="text.secondary">ID: {row.id}</Typography>
                                                    </Box>
                                                </Stack>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Stack direction="row" spacing={0.5} justifyContent="flex-end" alignItems="center">
                                                    <Typography variant="body2">{row.annotations}</Typography>
                                                    {smallAnnotationByImageId[Number(row.id)] === true && (
                                                        <Tooltip title={SMALL_BOX_TOOLTIP} arrow>
                                                            <WarningAmberIcon
                                                                sx={{
                                                                    color: "warning.dark",
                                                                    fontSize: 22,
                                                                    fontWeight: 900,
                                                                    lineHeight: 1,
                                                                    filter: "drop-shadow(0 0 1px rgba(0,0,0,0.35))",
                                                                    cursor: "help"
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </Stack>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Button size="small" variant="outlined"  onClick={() => handleClickOpen2(row.id, 'usage')}>Open</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                    {visibleImages.length === 0 && (
                                        <TableRow key="-1">
                                            <TableCell component="th" scope="row" colSpan={20}>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <InfoOutlinedIcon fontSize="small" />
                                                    <Typography variant="body2">
                                                        {showUnannotatedOnly
                                                            ? "No unannotated images found."
                                                            : "No usage examples have been uploaded yet"}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>

                {/* Annotator dialog */}
                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{ sx: { width: '100%', maxWidth: '1400px!important' } }}
                >
                    {currentItem && (
                       
                           <React.Fragment>
                               <Annotator
                                   img={currentItem}
                                   imageUrl={'/api/organisation/brands/img/' + currentItem.id}
                                   image_id={currentItem.id}
                                   onSave={onSaveDialog}
                                   brand_id={id}
                                   onDeleted={handleImageDeleted}
                                   onMoved={handleImageMoved}
                                   onDirtyChange={setAnnotatorDirty}
                                   registerSaveHandler={setAnnotatorSaveHandler}
                                   registerMoveHandler={setAnnotatorMoveHandler}
                                   registerDeleteHandler={setAnnotatorDeleteHandler}
                                   registerRedactHandler={setAnnotatorRedactHandler}
                               />
                               <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 2 }}>
                                   <Button onClick={() => requestNavigation(loadPrevItem)}>← Go Back</Button>
                                   <Stack
                                       direction="row"
                                       alignItems="center"
                                       spacing={0.25}
                                       sx={{
                                           px: 0.5,
                                           py: 0.25,
                                           border: "1px solid",
                                           borderColor: "divider",
                                           borderRadius: 1.5,
                                           backgroundColor: "background.paper"
                                       }}
                                   >
                                       <Tooltip title="Close" arrow>
                                           <IconButton aria-label="close" onClick={handleClose} size="small">
                                               <CloseIcon fontSize="small" />
                                           </IconButton>
                                       </Tooltip>
                                       <Tooltip title="Move image to another brand" arrow>
                                           <span>
                                               <IconButton
                                                   aria-label="move image"
                                                   color="primary"
                                                   onClick={() => annotatorMoveHandler?.()}
                                                   disabled={!annotatorMoveHandler}
                                                   size="small"
                                               >
                                                   <DriveFileMoveIcon fontSize="small" />
                                               </IconButton>
                                           </span>
                                       </Tooltip>
                                       <Tooltip title="Delete image" arrow>
                                           <span>
                                               <IconButton
                                                   aria-label="delete image"
                                                   color="error"
                                                   onClick={() => annotatorDeleteHandler?.()}
                                                   disabled={!annotatorDeleteHandler}
                                                   size="small"
                                               >
                                                   <DeleteIcon fontSize="small" />
                                               </IconButton>
                                           </span>
                                       </Tooltip>
                                       <Tooltip title="Add redact box" arrow>
                                           <span>
                                               <IconButton
                                                   aria-label="redact area"
                                                   color="warning"
                                                   onClick={() => annotatorRedactHandler?.()}
                                                   disabled={!annotatorRedactHandler}
                                                   size="small"
                                               >
                                                   <CropSquareIcon fontSize="small" />
                                               </IconButton>
                                           </span>
                                       </Tooltip>
                                       <Typography variant="body2" color="text.secondary" sx={{ minWidth: 56, textAlign: "center", px: 0.75 }}>
                                           {visibleImages.length > 0 ? currentIndex + 1 : 0} / {visibleImages.length}
                                       </Typography>
                                   </Stack>
                                   <Button onClick={() => requestNavigation(loadNextItem)}>Next →</Button>
                               </Stack>
                           </React.Fragment>

                    )}
                </Dialog>
                <Dialog
                    open={confirmNavOpen}
                    onClose={handleConfirmCancel}
                >
                    <DialogTitle>You have unsaved changes</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Save and continue, continue without saving, or cancel.
                        </DialogContentText>
                        {confirmNavError && (
                            <Alert severity="error" sx={{ mt: 1 }}>{confirmNavError}</Alert>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmSaveAndContinue} variant="contained">
                            Save and continue
                        </Button>
                        <Button onClick={handleConfirmDiscardAndContinue} color="warning">
                            Do not save and continue
                        </Button>
                        <Button onClick={handleConfirmCancel}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
    
    return (<div>{loading ? loadingView() : loadedView()}</div>);
}
